import { Box, Button, Typography } from "@mui/material";
import CenteredPaper from "../layouts/CenteredPaper";

export default function Custom404Page() {
  return (
    <CenteredPaper>
      <Box
        my={10}
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        gap={1}
      >
        <Typography variant="h3">404</Typography>

        <Typography variant="body1">
          We're sorry, the page you're looking for couldn't be found.
        </Typography>

        <Box mt={2}>
          <Button variant="text" href="/" sx={{ color: "white" }}>
            Back to Home
          </Button>
        </Box>
      </Box>
    </CenteredPaper>
  );
}
